// La mesa en la que está el camarero se cobró, cerró o movió en OTRO dispositivo
// (en directo o mientras el móvil estaba en el bolsillo). Misma salida que
// cuando otro dispositivo toma la mesa (MesaLeaseBridge), salvo lo no enviado:
// aquí la cuenta ya no existe, así que se DESCARTA (no se guarda en el borrador:
// la mesa queda libre y a los siguientes clientes no les debe aparecer) y el
// aviso dice qué productos eran para que el camarero pueda avisar o reponerlos.
import { mesaKicked } from "src/redux/actions/mesaKick";
import { cleanMesa, setSelectedIdMesaSuccess } from "src/redux/slices/mesas";
import { cleanHistoryMesa, resetCart } from "src/redux/slices/product";
import { postActionRoute } from "src/utils/postActionRoute";
import { showSnackbar } from "src/utils/globalSnackbar";
import {
  closedElsewhereMessage,
  sameId,
  unsentLinesOf,
  validId,
} from "./selectedMesaClosedCore";

export { closedElsewhereMessage, mesaLabelOf, selectedMesaSnapshot, shouldLeaveClosedMesa, summarizeLines, unsentLinesOf } from "./selectedMesaClosedCore";

export function leaveClosedMesa({ dispatch, getState, history, user, mesaId }) {
  if (!dispatch || !getState || !validId(mesaId)) return;
  const st = getState();
  const mesa = (st?.mesas?.mesas || []).find((m) => sameId(m?.id, mesaId));
  const product = st?.product || {};
  const draft = (product.checkoutHistory || []).find((d) => sameId(d?.idMesa, mesaId));
  const unsent = unsentLinesOf(product.checkout?.cart, draft?.checkout?.cart);
  dispatch(cleanHistoryMesa(mesaId));
  dispatch(mesaKicked(mesaId));
  dispatch(resetCart());
  dispatch(cleanMesa());
  dispatch(setSelectedIdMesaSuccess(-1));
  const target = user ? postActionRoute(user) : null;
  const path = history?.location?.pathname || (typeof window !== "undefined" ? window.location.pathname : "");
  if (target && history && path !== target) history.push(target);
  showSnackbar(closedElsewhereMessage(mesa, unsent), {
    variant: "info",
    preventDuplicate: true,
    autoHideDuration: 6000,
  });
}
